import { useTheme } from '@/context/ThemeContext';

const handleNav = (href: string) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

export default function Footer() {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <footer className={`px-6 md:px-10 pt-16 pb-8 transition-colors duration-500 ${
      isDark ? 'bg-[#071628] border-t border-white/5' : 'bg-[#0b1f3a] border-t border-white/5'
    }`}>
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-14">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img
              src="https://public.readdy.ai/ai/img_res/3ed4394e-93fa-477b-a2e7-70e95af71618.png"
              alt="Cornerstone AI Solutions"
              className="h-[90px] w-[90px] object-contain mb-4"
            />
            <p className="text-white/40 text-sm leading-relaxed max-w-xs mb-6">
              Operational intelligence for modern business. We build the systems that support your growth, protect your revenue, and ensure consistent performance.
            </p>
            <div className="flex gap-3">
              {[
                { icon: 'ri-linkedin-fill', href: '#' },
                { icon: 'ri-twitter-x-fill', href: '#' },
                { icon: 'ri-instagram-line', href: '#' },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/5 border border-white/10 text-white/50 hover:text-[#14b8c8] hover:border-[#14b8c8]/30 transition-colors duration-200 cursor-pointer"
                >
                  <i className={`${s.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Solutions */}
          <div>
            <h5 className="text-white/30 text-xs font-medium uppercase tracking-widest mb-5">Solutions</h5>
            <ul className="flex flex-col gap-3">
              {[
                { label: 'Intake Capture Systems', href: '#solutions' },
                { label: 'Conversion Systems', href: '#solutions' },
                { label: 'Workflow Automation', href: '#solutions' },
                { label: 'Industry Applications', href: '#industries' },
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
                    className="text-white/50 hover:text-white text-sm transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h5 className="text-white/30 text-xs font-medium uppercase tracking-widest mb-5">Company</h5>
            <ul className="flex flex-col gap-3">
              {[
                { label: 'How It Works', href: '#how-it-works' },
                { label: 'Benefits', href: '#benefits' },
                { label: 'Industries', href: '#industries' },
                { label: 'Contact Us', href: '#contact' },
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
                    className="text-white/50 hover:text-white text-sm transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/5 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs">
            &copy; {new Date().getFullYear()} Cornerstone AI Solutions. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" rel="nofollow" className="text-white/30 hover:text-white/60 text-xs transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" rel="nofollow" className="text-white/30 hover:text-white/60 text-xs transition-colors cursor-pointer">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}